import React, { useCallback } from 'react';
import clipboardCopy from 'clipboard-copy';
import { get } from 'lodash';
import { makeStyles, Chip, IconButton } from '@material-ui/core';
import { FileCopyOutlined } from '@material-ui/icons';
import { useRedirect } from 'react-admin';
import useCustomNotify from 'hooks/useCustomNotify';

const useStyles = makeStyles((theme) => ({
  copyWrapper: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    minWidth: 0,
    maxWidth: '100%',
  },
  copyValue: {
    minWidth: 0,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  copyButton: {
    flex: '0 0 auto',
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
  },
  chip: {
    height: 25,
    fontSize: 14,
    color: theme.palette.primary.main,
    backgroundColor: '#f3e8fe',
    marginTop: theme.spacing(1),
  },
}));

const cutId = (id: string) => (id.length > 20 ? `...${id.substring(id.length - 17)}` : id);

const OrderIdField = (props) => {
  const { record, baseSource, className, source, isSearched, resource, isCopyable } = props;

  const classes = useStyles();
  const redirect = useRedirect();
  const notify = useCustomNotify();

  const sellerSource = `${baseSource ? `${baseSource}.` : ''}sellerOrderId`;
  const marketplaceSource = `${baseSource ? `${baseSource}.` : ''}marketplaceOrderId`;

  const id = get(record, sellerSource) || get(record, marketplaceSource) || get(record, source);
  const groupId: string = get(record, 'groupId');

  const handleOpenGroup = useCallback(
    (e) => {
      e.stopPropagation();
      redirect(`/${resource}/groups/${groupId}/show`);
    },
    [groupId, redirect, resource]
  );

  const handleCopy = useCallback(
    (e) => {
      e.stopPropagation();

      clipboardCopy(id)
        .then(() => notify('Order number copied'))
        .catch((error) => notify(error.message, 'error'));
    },
    [id, notify]
  );

  if (!id) {
    return null;
  }

  if (isCopyable) {
    return (
      <>
        <div className={classes.copyWrapper} data-test="orderId">
          <div className={`${classes.copyValue} ${className || ''}`}>{id}</div>
          <IconButton
            className={classes.copyButton}
            aria-label="Copy order number"
            onClick={handleCopy}>
            <FileCopyOutlined fontSize="small" />
          </IconButton>
        </div>
        {!!groupId && isSearched && (
          <Chip {...props} className={classes.chip} onClick={handleOpenGroup} label="Grouped" />
        )}
      </>
    );
  }

  return (
    <>
      <div className={className} data-test="orderId">
        {cutId(id)}
      </div>
      {!!groupId && isSearched && (
        <Chip {...props} className={classes.chip} onClick={handleOpenGroup} label="Grouped" />
      )}
    </>
  );
};

export default OrderIdField;
